import { Property } from '@/api/types/categories.types';

export function getSearchWithoutChildProperties({
  propertyLegacyId,
  queryString,
  allProperties,
}: {
  propertyLegacyId: string;
  queryString: string;
  allProperties?: Property[];
}) {
  if (!allProperties) return queryString;

  const allChildrenPropertyIds = allProperties.reduce<string[]>(
    (acc, property) => {
      if (
        property.parentLegacyId &&
        (property.parentLegacyId === propertyLegacyId ||
          acc.includes(property.parentLegacyId))
      ) {
        return [...acc, property.legacyResourceId];
      }
      return acc;
    },
    []
  );

  const searchParams = new URLSearchParams(queryString);
  searchParams.forEach((_value, key) => {
    const propertyParam = key.match(/^p\[(\d+)]$/);
    if (propertyParam && allChildrenPropertyIds.includes(propertyParam[1])) {
      searchParams.delete(key);
    }
  });
  return searchParams.toString();
}
